// /OfflineStockButton.tsx
'use client';

interface OfflineStockButtonProps {
    onClick: () => void;
}

export default function OfflineStockButton({ onClick }: OfflineStockButtonProps) {
    return (
        <button
            onClick={onClick}
            className="animate-fadeIn -mt-7 ml-3 px-4 py-2 bg-[#64B704] hover:bg-[#64B704] active:bg-[#64B704] text-white rounded-lg flex items-center gap-2 transition-all duration-300 group"
        >
            <span className="md:text-sm text-xs font-medium">Есть в офлайн магазине</span>
            <svg
                className="w-4 h-4 animate-bounce group-hover:translate-y-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 14l-7 7m0 0l-7-7m7 7V3"
                />
            </svg>
        </button>
    );
}